import moment from 'jalali-moment';
import { groupBy } from 'lodash';
import { flatArray } from '@/utils';

export function mapItems(selfPrograms: SelfProgramsEntity, date: string) {

  const startDate = moment.from(date, 'YYYY-MM-DD').locale('en');

  const programs = flatArray<SelfMealEntity[]>(selfPrograms.selfWeekPrograms);

  if (selfPrograms.userWeekReserves) {
    for (const program of programs) {
      if (!program.programFoodTypes || !Array.isArray(program.programFoodTypes)) {
        program.programFoodTypes = [];
      }
    }
  }

  for (const program of programs) {
    program.programFoodTypes = program.programFoodTypes.map(foodType => {
      const userReserve = selfPrograms.userWeekReserves?.find((userReserve: any) => foodType.programId === userReserve.programId);
      return { ...foodType, ...(userReserve ?? {}) };
    });
  }

  const groupedPrograms = groupBy(programs, 'date');

  const dates = [];
  for (let i = 0; i < 7; i++) {
    dates.push(startDate.clone().add(i, 'day').format('YYYY-MM-DD'));
  }

  let groupedProgramsFilled: Dictionary<SelfMealEntity[]> = {};
  if (Object.keys(groupedPrograms).length !== 7) {
    for (const date of dates) {
      if (groupedPrograms[date]) {
        groupedProgramsFilled[date] = groupedPrograms[date];
      }
      else {
        groupedProgramsFilled[date] = [];
      }
    }
  }
  else {
    groupedProgramsFilled = groupedPrograms;
  }
  return { programs, groupedPrograms: groupedProgramsFilled };
}
